/**
 * WP Swiper Plugin - Hierarchical Menu
 * Version: 1.0.0
 */

(function($) {
    'use strict';
    
    var WPHierarchicalMenu = {
        
        init: function() {
            console.log('🚀 WPHierarchicalMenu initializing...');
            
            // 强制初始化编辑器菜单（无论环境如何）
            $(document).ready(function() {
                console.log('📄 Document ready, initializing all menus');
                WPHierarchicalMenu.initAllMenus();
                
                // 延迟再次初始化，确保编辑器完全加载
                setTimeout(function() {
                    console.log('⏰ Delayed initialization');
                    WPHierarchicalMenu.initAllMenus();
                }, 1000);
                
                // 再次延迟初始化
                setTimeout(function() {
                    console.log('⏰ Second delayed initialization');
                    WPHierarchicalMenu.initAllMenus();
                }, 3000);
            });
            
            // 检查是否在 Elementor 前端环境
            if (typeof elementorFrontend !== 'undefined') {
                console.log('✅ Elementor frontend detected');
                $(window).on('elementor/frontend/init', this.onElementorFrontendInit.bind(this));
            } else {
                console.log('⚠️ Elementor frontend not detected, using document ready');
                $(document).ready(this.initMenus.bind(this));
            }
            
            // 也监听窗口加载完成事件，确保所有内容都已加载
            $(window).on('load', function() {
                console.log('🔄 Window loaded, re-checking for menus...');
                WPHierarchicalMenu.initAllMenus();
            });
            
            // 在编辑器中也初始化菜单功能
            if (typeof elementor !== 'undefined') {
                console.log('✅ Elementor editor detected, initializing editor functionality');
                $(document).ready(function() {
                    // 延迟初始化，确保编辑器完全加载
                    setTimeout(function() {
                        WPHierarchicalMenu.initEditorMenus();
                    }, 1000);
                });
            }
        },
        
        initAllMenus: function() {
            console.log('🔄 initAllMenus called');
            $('.hierarchical-menu').each(function() {
                var $menu = $(this);
                console.log('🔍 Found menu in initAllMenus:', $menu);
                
                // 强制绑定事件
                WPHierarchicalMenu.bindEvents($menu);
                $menu.find('.hierarchical-menu__item').addClass('animate-in');
                
                // 标记为已初始化
                $menu.data('hierarchical-menu-initialized', true);
                console.log('✅ Menu initialized in initAllMenus');
            });
        },
        
        onElementorFrontendInit: function() {
            elementorFrontend.hooks.addAction('frontend/element_ready/hierarchical_menu.default', this.initWidget.bind(this));
        },
        
        initWidget: function($scope) {
            var $menu = $scope.find('.hierarchical-menu');
            if ($menu.length) {
                console.log('🎯 Initializing hierarchical menu widget:', $menu);
                this.bindEvents($menu);
                this.initMenuAnimation($menu);
                
                // Debug: Log the complete HTML structure
                console.log('🔍 Menu HTML structure:', $menu[0].outerHTML);
            } else {
                console.warn('❌ No .hierarchical-menu found in scope:', $scope);
            }
        },
        
        initMenus: function() {
            console.log('🚀 Initializing all hierarchical menus on page');
            $('.hierarchical-menu').each(function() {
                var $menu = $(this);
                console.log('🔍 Found menu:', $menu);
                WPHierarchicalMenu.bindEvents($menu);
                WPHierarchicalMenu.initMenuAnimation($menu);
            });
        },
        
        initEditorMenus: function() {
            console.log('🎨 Initializing hierarchical menus in editor');
            
            // 直接在当前页面查找菜单（编辑器预览区域）
            $('.hierarchical-menu').each(function() {
                var $menu = $(this);
                console.log('🔍 Found editor menu:', $menu);
                
                // 检查是否已经初始化过
                if (!$menu.data('hierarchical-menu-initialized')) {
                    WPHierarchicalMenu.bindEvents($menu);
                    $menu.find('.hierarchical-menu__item').addClass('animate-in');
                    $menu.data('hierarchical-menu-initialized', true);
                    console.log('✅ Editor menu initialized');
                }
            });
            
            // 也尝试在 iframe 中查找（如果存在）
            var $iframe = $('#elementor-preview-iframe');
            if ($iframe.length) {
                try {
                    var iframeDoc = $iframe.contents();
                    iframeDoc.find('.hierarchical-menu').each(function() {
                        var $menu = $(this);
                        console.log('🔍 Found iframe menu:', $menu);
                        
                        if (!$menu.data('hierarchical-menu-initialized')) {
                            WPHierarchicalMenu.bindEvents($menu);
                            $menu.find('.hierarchical-menu__item').addClass('animate-in');
                            $menu.data('hierarchical-menu-initialized', true);
                            console.log('✅ Iframe menu initialized');
                        }
                    });
                } catch (e) {
                    console.log('⚠️ Cannot access iframe content:', e);
                }
            }
            
            // 监听 Elementor 编辑器事件，当内容更新时重新初始化
            if (typeof elementor !== 'undefined' && elementor.channels && elementor.channels.editor) {
                // 移除之前的监听器，避免重复绑定
                elementor.channels.editor.off('change:hierarchical_menu');
                
                // 监听编辑器变化
                elementor.channels.editor.on('change:hierarchical_menu', function() {
                    console.log('🔄 Editor content changed, re-initializing menus');
                    setTimeout(function() {
                        WPHierarchicalMenu.initEditorMenus();
                    }, 300);
                });
            }
        },
        
        bindEvents: function($menu) {
            console.log('🔧 Binding events for hierarchical menu:', $menu);
            
            // Debug: Check what elements exist
            var $arrows = $menu.find('.hierarchical-menu__arrow');
            var $items = $menu.find('.hierarchical-menu__item');
            var $submenuLayers = $menu.find('.hierarchical-menu__submenu-layer');
            
            console.log('🔍 Found elements:', {
                arrows: $arrows.length,
                items: $items.length,
                submenuLayers: $submenuLayers.length
            });
            
            // 移除之前的事件监听器，避免重复绑定
            $menu.off('click.hierarchical-menu');
            
            // 检查是否在编辑器中
            var isEditor = $menu.closest('.elementor-editor-active').length > 0 || 
                          $('body').hasClass('elementor-editor-active') ||
                          typeof elementor !== 'undefined';
            
            console.log('🔍 Editor detection result:', isEditor);
            
            if (isEditor) {
                console.log('🎨 Editor mode detected, using direct layer switching');
                // 在编辑器中，箭头点击直接切换层级显示
                $menu.on('click.hierarchical-menu', '.hierarchical-menu__arrow', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    var submenuIndex = $(this).data('submenu-index');
                    var targetLayer = 'submenu-' + submenuIndex;
                    
                    console.log('🎯 Editor arrow clicked, switching to layer:', targetLayer);
                    WPHierarchicalMenu.showEditorLayer($menu, targetLayer);
                });
                
                // 返回按钮在编辑器中切换回主菜单
                $menu.on('click.hierarchical-menu', '.hierarchical-menu__back', function(e) {
                    e.preventDefault();
                    console.log('🔙 Editor back button clicked');
                    WPHierarchicalMenu.showEditorLayer($menu, 'main');
                });
            } else {
                console.log('🌐 Frontend mode detected, using slide animation');
                // 在前端，使用原有的滑动动画
                $menu.on('click.hierarchical-menu', '.hierarchical-menu__arrow', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    var submenuIndex = $(this).data('submenu-index');
                    console.log('🎯 Arrow clicked, submenu index:', submenuIndex);
                    WPHierarchicalMenu.openSubmenu($menu, submenuIndex);
                });
                
                // 菜单项空白区域点击 - 打开子菜单（如果有）
                $menu.on('click.hierarchical-menu', '.hierarchical-menu__item', function(e) {
                    var $arrow = $(this).find('.hierarchical-menu__arrow');
                    
                    console.log('🎯 Menu item clicked:', {
                        target: e.target.className,
                        hasArrow: $arrow.length > 0
                    });
                    
                    // 如果点击的是链接文字，不处理
                    if ($(e.target).hasClass('hierarchical-menu__item-text') || $(e.target).closest('.hierarchical-menu__item-text').length) {
                        console.log('📝 Link text clicked, ignoring');
                        return;
                    }
                    
                    // 如果点击的是箭头，不重复处理
                    if ($(e.target).hasClass('hierarchical-menu__arrow') || $(e.target).closest('.hierarchical-menu__arrow').length) {
                        console.log('🎯 Arrow clicked, handled by arrow event');
                        return;
                    }
                    
                    // 如果有箭头，打开子菜单
                    if ($arrow.length) {
                        e.preventDefault();
                        var submenuIndex = $arrow.data('submenu-index');
                        console.log('🎯 Opening submenu from item click, index:', submenuIndex);
                        WPHierarchicalMenu.openSubmenu($menu, submenuIndex);
                    }
                });
                
                // 返回按钮
                $menu.on('click.hierarchical-menu', '.hierarchical-menu__back', function(e) {
                    e.preventDefault();
                    console.log('🔙 Back button clicked');
                    WPHierarchicalMenu.closeSubmenu($menu);
                });
            }
            
            // 关闭按钮（编辑器和前端都适用）
            $menu.on('click.hierarchical-menu', '.hierarchical-menu__close', function(e) {
                e.preventDefault();
                console.log('❌ Close menu clicked');
            });
        },
        
        showEditorLayer: function($menu, targetLayer) {
            console.log('🔄 Showing editor layer:', targetLayer);
            
            // 隐藏所有层
            $menu.find('.hierarchical-menu__editor-layer').hide().css({
                'display': 'none',
                'opacity': '0',
                'visibility': 'hidden'
            });
            
            // 显示目标层
            if (targetLayer === 'main') {
                $menu.find('.hierarchical-menu__main-layer').show().css({
                    'display': 'block',
                    'opacity': '1',
                    'visibility': 'visible'
                });
            } else {
                // 处理子菜单层，格式如 "submenu-0", "submenu-1" 等
                var submenuIndex = targetLayer.replace('submenu-', '');
                
                // 尝试多种选择器来查找子菜单层
                var $targetSubmenu = $menu.find('.hierarchical-menu__submenu-layer[data-layer-id="' + targetLayer + '"]');
                if (!$targetSubmenu.length) {
                    $targetSubmenu = $menu.find('.hierarchical-menu__submenu-layer[data-submenu-index="' + submenuIndex + '"]');
                }
                
                console.log('🔍 Looking for submenu layer:', {
                    targetLayer: targetLayer,
                    submenuIndex: submenuIndex,
                    found: $targetSubmenu.length,
                    allSubmenuLayers: $menu.find('.hierarchical-menu__submenu-layer').map(function() {
                        return {
                            layerId: $(this).data('layer-id'),
                            submenuIndex: $(this).data('submenu-index'),
                            element: this
                        };
                    }).get()
                });
                
                if ($targetSubmenu.length) {
                    $targetSubmenu.show().css({
                        'display': 'block',
                        'opacity': '1',
                        'visibility': 'visible'
                    });
                    console.log('✅ Successfully switched to submenu layer:', targetLayer);
                } else {
                    console.warn('❌ Target submenu layer not found:', targetLayer);
                    // 回退到主菜单
                    $menu.find('.hierarchical-menu__main-layer').show().css({
                        'display': 'block',
                        'opacity': '1',
                        'visibility': 'visible'
                    });
                }
            }
        },
        
        openSubmenu: function($menu, submenuIndex) {
            console.log('🚀 Opening submenu:', submenuIndex);
            
            var $mainLayer = $menu.find('.hierarchical-menu__main-layer');
            var $submenuLayer = $menu.find('.hierarchical-menu__submenu-layer[data-submenu-index="' + submenuIndex + '"]');
            
            console.log('🔍 Found layers:', {
                mainLayer: $mainLayer.length,
                submenuLayer: $submenuLayer.length,
                submenuSelector: '.hierarchical-menu__submenu-layer[data-submenu-index="' + submenuIndex + '"]'
            });
            
            // Debug: Log all submenu layers and their indices
            var $allSubmenuLayers = $menu.find('.hierarchical-menu__submenu-layer');
            console.log('🔍 All submenu layers:', $allSubmenuLayers.map(function() {
                return {
                    element: this,
                    index: $(this).data('submenu-index'),
                    classes: this.className
                };
            }).get());
            
            if ($submenuLayer.length) {
                console.log('✅ Adding classes for slide animation');
                $mainLayer.addClass('is-hidden');
                $submenuLayer.addClass('is-active');
                
                // Debug: Check if classes were applied
                setTimeout(function() {
                    console.log('🔍 Classes after animation:', {
                        mainHidden: $mainLayer.hasClass('is-hidden'),
                        submenuActive: $submenuLayer.hasClass('is-active'),
                        mainLayerTransform: $mainLayer.css('transform'),
                        submenuLayerTransform: $submenuLayer.css('transform')
                    });
                }, 100);
            } else {
                console.warn('❌ Submenu layer not found for index:', submenuIndex);
                // Debug: List all available submenu layers
                var $allSubmenuLayers = $menu.find('.hierarchical-menu__submenu-layer');
                console.log('🔍 Available submenu layers:', $allSubmenuLayers.map(function() {
                    return $(this).data('submenu-index');
                }).get());
            }
        },
        
        closeSubmenu: function($menu) {
            console.log('🔙 Closing submenu');
            
            var $mainLayer = $menu.find('.hierarchical-menu__main-layer');
            var $activeSubmenu = $menu.find('.hierarchical-menu__submenu-layer.is-active');
            
            console.log('🔍 Found layers for closing:', {
                mainLayer: $mainLayer.length,
                activeSubmenu: $activeSubmenu.length
            });
            
            $mainLayer.removeClass('is-hidden');
            $activeSubmenu.removeClass('is-active');
            
            // Debug: Check if classes were removed
            setTimeout(function() {
                console.log('🔍 Classes after closing:', {
                    mainHidden: $mainLayer.hasClass('is-hidden'),
                    submenuActive: $activeSubmenu.hasClass('is-active')
                });
            }, 100);
        },
        
        initMenuAnimation: function($menu) {
            // 检查是否启用动画
            var enableAnimation = $menu.data('enable-animation');
            if (enableAnimation !== 'yes') {
                // 如果禁用动画，直接显示所有菜单项
                $menu.find('.hierarchical-menu__main-layer .hierarchical-menu__item').addClass('animate-in');
                return;
            }
            
            // 检查菜单是否在视口中，如果是则立即触发动画
            var $mainLayer = $menu.find('.hierarchical-menu__main-layer');
            
            if (this.isElementInViewport($mainLayer[0])) {
                this.animateMenuItems($menu);
            } else {
                // 使用 Intersection Observer 监听菜单进入视口
                if ('IntersectionObserver' in window) {
                    var observer = new IntersectionObserver(function(entries) {
                        entries.forEach(function(entry) {
                            if (entry.isIntersecting) {
                                WPHierarchicalMenu.animateMenuItems($menu);
                                observer.unobserve(entry.target);
                            }
                        });
                    }, {
                        threshold: 0.1
                    });
                    
                    observer.observe($mainLayer[0]);
                } else {
                    // 降级处理：直接触发动画
                    this.animateMenuItems($menu);
                }
            }
        },
        
        isElementInViewport: function(el) {
            var rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        },
        
        animateMenuItems: function($menu) {
            var $items = $menu.find('.hierarchical-menu__main-layer .hierarchical-menu__item');
            var delay = 0;
            var staggerDelay = parseInt($menu.data('animation-delay')) || 100; // 从设置中获取延迟时间
            
            $items.each(function() {
                var $item = $(this);
                
                setTimeout(function() {
                    $item.addClass('animate-in');
                }, delay);
                
                delay += staggerDelay;
            });
        }
    };
    
    WPHierarchicalMenu.init();
    
    window.WPHierarchicalMenu = WPHierarchicalMenu;
    
})(jQuery);
